// Preview opens fullUrl, the copy with the "Digitally Altered" watermark baked in, so brokers can verify what
// buyer and partner surfaces receive rather than the clean image the Media tab shows them. A photo uploaded in
// this session has no baked copy yet, so fall back to its url. Shared by each photo's own Preview item and the
// Media tab's bulk Preview so the two open the same thing.
export function openPhotoPreview({ fullUrl, url }: { fullUrl?: string, url?: string }): void {
  const photoUrl = fullUrl || url;
  if (!photoUrl) return;

  window.open(photoUrl, '_blank');
}
